import { createReducer } from "reduxsauce";
import ReducerRegister from "../../../../ReducerRegister";
import { ActionTypes } from "../../../../actionTypes/screens/admin/agent/teacheraccount/EditActionTypes";
import EditService from "../../../../../services/screens/admin/agent/teacheraccount/EditService"
import AsyncActionReducers from "../../../../AsyncActionReducers";

import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.agent.teacheraccount.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (vo) => {
        return (dispatch) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, vo });

            EditService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveTeacherAccountAsync: (vo) => {
        return (dispatch) => {
            dispatch({ type: ActionTypes.SAVE_TEACHER_ACCOUNT_ASYNC, vo });

            EditService.addTeacherAccount(vo,
                response => {
                    dispatch(Actions.saveTeacherAccountSuccess(response));
                },
                error => {
                    dispatch(Actions.saveTeacherAccountFailure(error));
                }
            );
        };
    },

    saveTeacherAccountSuccess: data => ({
        type: ActionTypes.SAVE_TEACHER_ACCOUNT_SUCCESS,
        parentType: ActionTypes.SAVE_TEACHER_ACCOUNT_ASYNC,
        postReducer: saveTeacherAccountSuccessPostReducer,
        data
    }),

    saveTeacherAccountFailure: error => ({
        type: ActionTypes.SAVE_TEACHER_ACCOUNT_FAILURE,
        parentType: ActionTypes.SAVE_TEACHER_ACCOUNT_ASYNC,
        error
    }),
};

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
    teacherInfo: null,
    sendPwd: null,
};

/* ------------- Reducers ------------- */
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, teacherInfo: {...data.teacherInfo}};
};

const saveTeacherAccountSuccessPostReducer = (state, { data }) => {
    return { ...state, sendPwd: data.sendPwd };
};

/* ------------- Hookup Reducers To Types ------------- */

const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_TEACHER_ACCOUNT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_TEACHER_ACCOUNT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_TEACHER_ACCOUNT_FAILURE]: AsyncActionReducers.failureReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };